const legalFormItems = [
    { titleSelect: 'Village Business Unit (BUUD)', valSelect: '01' },
    { titleSelect: 'Commanditer Venotschap (CV)', valSelect: '02' },
    { titleSelect: 'Group Debtors', valSelect: '03' },
    { titleSelect: 'Shipping Expedition (EMKL)', valSelect: '04' },
    { titleSelect: 'FIRM', valSelect: '05' },
    { titleSelect: 'Combined Cooperatives', valSelect: '06' },
    { titleSelect: 'Parent Cooperative', valSelect: '07' },
    { titleSelect: 'Cooperative', valSelect: '08' },
    { titleSelect: 'Village Unit Cooperative', valSelect: '09' },
    { titleSelect: 'Limited', valSelect: '10' },
    { titleSelect: 'Airlines of Indonesia', valSelect: '11' },
    { titleSelect: 'Namloose Venotschaap', valSelect: '12' },
    { titleSelect: 'Regional Company', valSelect: '13' },
    { titleSelect: 'Limited - Persero', valSelect: '14' },
    { titleSelect: 'The Civil Guild', valSelect: '15' },
    { titleSelect: 'Public Company', valSelect: '16' },
    { titleSelect: 'Primary Cooperative', valSelect: '17' },
    { titleSelect: 'limited liability company', valSelect: '18' },
    { titleSelect: 'Center for Cooperatives', valSelect: '19' },
    { titleSelect: 'Village Unit Cooperative Center', valSelect: '20' },
    { titleSelect: 'Business Trade', valSelect: '21' },
    { titleSelect: 'Rural Credit Units', valSelect: '22' },
    { titleSelect: 'Foundation', valSelect: '23' },
    { titleSelect: 'Regional Company Company', valSelect: '24' },
    { titleSelect: 'Regional Public Companies', valSelect: '25' },
    { titleSelect: 'Other Business Entities', valSelect: '99' },
]

export default legalFormItems;